//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 21.12.2016.
 */

(function () {

    'use strict';

    angular.module('container.widgets')
        .factory('tableColumnDateFilterService', tableColumnDateFilterService);

    function tableColumnDateFilterService(sortService, $filter) {

        let service = {};

        service.filter = data => {

            let filteredItems = data.unfilteredItems.slice();

            // Filter by date range
            if (data.fromDate != null && data.fromDate.isoDate != null && 
                data.toDate != null && data.toDate.isoDate != null) {

                filteredItems = filteredItems.filter(item => {
                    return moment.utc(item[data.columnKey]).isBetween(moment.utc(data.fromDate.isoDate), moment.utc(data.toDate.isoDate), null, '[]');
                });
            }

            // Filter by date string
            if (data.searchText) {

                filteredItems = filteredItems.filter(item => {
                    return `UTC ${$filter('date')(item[data.columnKey], 'yyyy-MM-dd HH:mm', '+0000')}`.toString().indexOf(data.searchText) > -1;
                });
            }

            // Sort by direction
            if (data.column.sortDirection) {
                filteredItems = sortService.sortItemsByDate(filteredItems, data.columnKey, data.column.sortDirection);
            }

            data.itemsFiltered(filteredItems);
        };

        return service;
    }
})();